export const picklistSupplierCatalogItemDefaultValues = {
  quantity: 0,
  quantityUnitOfMeasure: 0,
  quantityRemainder: 0,
};
